import snowflakeLogo from '../../../../images/snowflakelogo.png';
import bigqueryLogo from '../../../../images/bigquerylogo.png';
import redshiftLogo from '../../../../images/redshiftlogo.png';
import kafkaLogo from '../../../../images/kafkalogo.png';
import lookerLogo from '../../../../images/lookerlogo.png';
import tableauLogo from '../../../../images/tableaulogo.png';
import mysqlLogo from '../../../../images/mysqllogo-2.png';
import postgresLogo from '../../../../images/postgreslogo.png';
import mongodbLogo from '../../../../images/mongodblogo.png';
import azureLogo from '../../../../images/azure-ad.png';
import oktaLogo from '../../../../images/oktalogo.png';
import glueLogo from '../../../../images/gluelogo.png';
import oracleLogo from '../../../../images/oraclelogo.png';
import hiveLogo from '../../../../images/hivelogo.png';
import supersetLogo from '../../../../images/supersetlogo.png';
import athenaLogo from '../../../../images/awsathenalogo.png';
import mssqlLogo from '../../../../images/mssqllogo.png';
import clickhouseLogo from '../../../../images/clickhouselogo.png';
import trinoLogo from '../../../../images/trinologo.png';
import dbtLogo from '../../../../images/dbtlogo.png';
import druidLogo from '../../../../images/druidlogo.png';
import elasticsearchLogo from '../../../../images/elasticsearchlogo.png';
import feastLogo from '../../../../images/feastlogo.png';
import mariadbLogo from '../../../../images/mariadblogo.png';
import metabaseLogo from '../../../../images/metabaselogo.png';
import powerbiLogo from '../../../../images/powerbilogo.png';
import modeLogo from '../../../../images/modelogo.png';
import databricksLogo from '../../../../images/databrickslogo.png';
import verticaLogo from '../../../../images/verticalogo.png';
import mlflowLogo from '../../../../images/mlflowlogo.png';
import dynamodbLogo from '../../../../images/dynamodblogo.png';
import xmlLogo from '../../../../images/xml-logo.png';
import iconFile from '../../../../images/icon-file.svg';
import cassandraLogo from '../../../../images/cassandralogo.png';
import datahubLogo from '../../../../images/datahublogo.png';

export const ATHENA = 'athena';
export const ATHENA_URN = `urn:li:dataPlatform:${ATHENA}`;
export const AZURE = 'azure-ad';
export const AZURE_URN = `urn:li:dataPlatform:${AZURE}`;
export const BIGQUERY = 'bigquery';
export const BIGQUERY_USAGE = 'bigquery-usage';
export const BIGQUERY_BETA = 'bigquery-beta';
export const BIGQUERY_URN = `urn:li:dataPlatform:${BIGQUERY}`;
export const CLICKHOUSE = 'clickhouse';
export const CLICKHOUSE_USAGE = 'clickhouse-usage';
export const CLICKHOUSE_URN = `urn:li:dataPlatform:${CLICKHOUSE}`;
export const DBT = 'dbt';
export const DBT_URN = `urn:li:dataPlatform:${DBT}`;
export const DRUID = 'druid';
export const DRUID_URN = `urn:li:dataPlatform:${DRUID}`;
export const DYNAMODB = 'dynamodb';
export const DYNAMODB_URN = `urn:li:dataPlatform:${DYNAMODB}`;
export const ELASTICSEARCH = 'elasticsearch';
export const ELASTICSEARCH_URN = `urn:li:dataPlatform:${ELASTICSEARCH}`;
export const FEAST = 'feast';
export const FEAST_LEGACY = 'feast-legacy';
export const FEAST_URN = `urn:li:dataPlatform:${FEAST}`;
export const GLUE = 'glue';
export const GLUE_URN = `urn:li:dataPlatform:${GLUE}`;
export const HIVE = 'hive';
export const HIVE_URN = `urn:li:dataPlatform:${HIVE}`;
export const KAFKA = 'kafka';
export const KAFKA_URN = `urn:li:dataPlatform:${KAFKA}`;
export const LOOKER = 'looker';
export const LOOK_ML = 'lookml';
export const LOOKER_URN = `urn:li:dataPlatform:${LOOKER}`;
export const MARIA_DB = 'mariadb';
export const MARIA_DB_URN = `urn:li:dataPlatform:${MARIA_DB}`;
export const METABASE = 'metabase';
export const METABASE_URN = `urn:li:dataPlatform:${METABASE}`;
export const MLFLOW = 'mlflow';
export const MLFLOW_URN = `urn:li:dataPlatform:${MLFLOW}`;
export const MODE = 'mode';
export const MODE_URN = `urn:li:dataPlatform:${MODE}`;
export const MONGO_DB = 'mongodb';
export const MONGO_DB_URN = `urn:li:dataPlatform:${MONGO_DB}`;
export const MSSQL = 'mssql';
export const MSSQL_URN = `urn:li:dataPlatform:${MSSQL}`;
export const MYSQL = 'mysql';
export const MYSQL_URN = `urn:li:dataPlatform:${MYSQL}`;
export const OKTA = 'okta';
export const OKTA_URN = `urn:li:dataPlatform:${OKTA}`;
export const ORACLE = 'oracle';
export const ORACLE_URN = `urn:li:dataPlatform:${ORACLE}`;
export const POSTGRES = 'postgres';
export const POSTGRES_URN = `urn:li:dataPlatform:${POSTGRES}`;
export const POWER_BI = 'powerbi';
export const POWER_BI_URN = `urn:li:dataPlatform:${POWER_BI}`;
export const REDSHIFT = 'redshift';
export const REDSHIFT_USAGE = 'redshift-usage';
export const REDSHIFT_URN = `urn:li:dataPlatform:${REDSHIFT}`;
export const SNOWFLAKE = 'snowflake';
export const SNOWFLAKE_BETA = 'snowflake-beta';
export const SNOWFLAKE_USAGE = 'snowflake-usage';
export const SNOWFLAKE_URN = `urn:li:dataPlatform:${SNOWFLAKE}`;
export const STARBURST_TRINO_USAGE = 'starburst-trino-usage';
export const SUPERSET = 'superset';
export const SUPERSET_URN = `urn:li:dataPlatform:${SUPERSET}`;
export const TABLEAU = 'tableau';
export const TABLEAU_URN = `urn:li:dataPlatform:${TABLEAU}`;
export const TRINO = 'trino';
export const TRINO_URN = `urn:li:dataPlatform:${TRINO}`;
export const CUSTOM = 'custom';
export const CUSTOM_URN = `urn:li:dataPlatform:${CUSTOM}`;
export const UNITY_CATALOG = 'unity-catalog';
export const UNITY_CATALOG_URN = `urn:li:dataPlatform:${UNITY_CATALOG}`;
export const DBT_CLOUD = 'dbt-cloud';
export const DBT_CLOUD_URN = `urn:li:dataPlatform:dbt`;
export const VERTICA = 'vertica';
export const VERTICA_URN = `urn:li:dataPlatform:${VERTICA}`;
export const XML = 'xml-files';
export const XML_URN = `urn:li:dataPlatform:${XML}`;
export const FILE = 'file';
export const FILE_URN = `urn:li:dataPlatform:${FILE}`;
export const CASSANDRA = 'cassandra';
export const CASSANDRA_URN = `urn:li:dataPlatform:${CASSANDRA}`;
export const DATAHUB = 'datahub';
export const DATAHUB_GC = 'datahub-gc';
export const DATAHUB_LINEAGE_FILE = 'datahub-lineage-file';
export const DATAHUB_BUSINESS_GLOSSARY = 'datahub-business-glossary';
export const DATAHUB_URN = `urn:li:dataPlatform:${DATAHUB}`;

export const PLATFORM_URN_TO_LOGO = {
    [ATHENA_URN]: athenaLogo,
    [AZURE_URN]: azureLogo,
    [BIGQUERY_URN]: bigqueryLogo,
    [CLICKHOUSE_URN]: clickhouseLogo,
    [DBT_URN]: dbtLogo,
    [DRUID_URN]: druidLogo,
    [DYNAMODB_URN]: dynamodbLogo,
    [ELASTICSEARCH_URN]: elasticsearchLogo,
    [FEAST_URN]: feastLogo,
    [GLUE_URN]: glueLogo,
    [HIVE_URN]: hiveLogo,
    [KAFKA_URN]: kafkaLogo,
    [LOOKER_URN]: lookerLogo,
    [MARIA_DB_URN]: mariadbLogo,
    [METABASE_URN]: metabaseLogo,
    [MLFLOW_URN]: mlflowLogo,
    [MODE_URN]: modeLogo,
    [MONGO_DB_URN]: mongodbLogo,
    [MSSQL_URN]: mssqlLogo,
    [MYSQL_URN]: mysqlLogo,
    [OKTA_URN]: oktaLogo,
    [ORACLE_URN]: oracleLogo,
    [POSTGRES_URN]: postgresLogo,
    [POWER_BI_URN]: powerbiLogo,
    [REDSHIFT_URN]: redshiftLogo,
    [SNOWFLAKE_URN]: snowflakeLogo,
    [TABLEAU_URN]: tableauLogo,
    [TRINO_URN]: trinoLogo,
    [SUPERSET_URN]: supersetLogo,
    [UNITY_CATALOG_URN]: databricksLogo,
    [VERTICA_URN]: verticaLogo,
    [XML_URN]: xmlLogo,
    [FILE_URN]: iconFile,
    [CASSANDRA_URN]: cassandraLogo,
    [DATAHUB_URN]: datahubLogo,
};

export const SOURCE_TO_PLATFORM_URN = {
    [BIGQUERY_BETA]: BIGQUERY_URN,
    [BIGQUERY_USAGE]: BIGQUERY_URN,
    [CLICKHOUSE_USAGE]: CLICKHOUSE_URN,
    [FEAST_LEGACY]: FEAST_URN,
    [LOOK_ML]: LOOKER_URN,
    [REDSHIFT_USAGE]: REDSHIFT_URN,
    [SNOWFLAKE_BETA]: SNOWFLAKE_URN,
    [SNOWFLAKE_USAGE]: SNOWFLAKE_URN,
    [STARBURST_TRINO_USAGE]: TRINO_URN,
    [DBT_CLOUD]: DBT_URN,
    [VERTICA]: VERTICA_URN,
};
